import React from 'react';
import { TableRow, TableHeaderColumn } from 'material-ui';
import R from 'ramda';
import AssigneeFilter from '../generic-components/assignee-filter';
import PriorityFilter from '../generic-components/priority-filter';

const RateConversionTableHeader = ({
  sort,
  getSortIcon,
  sortValue,
  sortRule,
  assigneeFilter,
  filterByAssignee,
  priorityFilter,
  filterByPriority,
}) => {
  return (
    <TableRow>
      <TableHeaderColumn colSpan="1" />
      <TableHeaderColumn colSpan="6" style={{ padding: 0 }}>
        Contract
      </TableHeaderColumn>
      <TableHeaderColumn
        data-walkthru="contractListStatus"
        colSpan="2"
        style={{ padding: '0 0 0 8px' }}
      >
        <div
          className="flex-tc-sb"
          style={{ justifyContent: 'center', cursor: 'pointer' }}
          onClick={() => sort('rateConversionStatus')}
        >
          Rate Conversion Status{' '}
          {getSortIcon(R.equals('rateConversionStatus', sortValue), sortRule)}
        </div>
      </TableHeaderColumn>
      <TableHeaderColumn data-walkthru="priority" colSpan="1" style={{ padding: 0 }}>
        <PriorityFilter filter={priorityFilter} filterByPriority={filterByPriority} />
      </TableHeaderColumn>
      <TableHeaderColumn colSpan="1" style={{ padding: 0, overflow: 'hidden' }}>
        <AssigneeFilter filter={assigneeFilter} filterByAssignee={filterByAssignee} isContainer />
      </TableHeaderColumn>
      <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }}>
        Periods
      </TableHeaderColumn>
      <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }}>
        <div
          className="flex-tc-sb"
          style={{ justifyContent: 'center', cursor: 'pointer' }}
          onClick={() => sort('updatedAt')}
        >
          Modified {getSortIcon(R.equals('updatedAt', sortValue), sortRule)}
        </div>
      </TableHeaderColumn>
      <TableHeaderColumn colSpan="2" style={{ padding: 0 }}>
        Contacts &nbsp; Notes &nbsp; Activity
      </TableHeaderColumn>
    </TableRow>
  );
};

export default RateConversionTableHeader;



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/rate-conversion-table-header.jsx